'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lodash = require('lodash');
var index = require('./index.js');

const getTheme = (path) => lodash.get(index["default"], path);

exports.getTheme = getTheme;
//# sourceMappingURL=themes.js.map
